import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import type { SearchModalFilterChip } from '../search-modal.interface'

import { SearchFilterChip } from './SearchFilterChip'

import styles from '../SearchModal.module.scss'

type SearchChipsProps = {
  activeFilterChipId?: string | null
  filterChips?: readonly SearchModalFilterChip[]
  onFilterChipChange?: (id: string) => void
}

export function SearchChips({ activeFilterChipId, filterChips, onFilterChipChange }: SearchChipsProps) {
  if (filterChips === undefined || filterChips.length === 0) {
    return null
  }

  return (
    <div className={styles.chipsScroll} data-testid={SEARCH_MODAL_TEST_IDS.chips}>
      {filterChips.map((chip) => {
        const disabled = chip.disabled || onFilterChipChange === undefined

        return (
          <SearchFilterChip
            key={chip.id}
            active={chip.id === activeFilterChipId}
            disabled={disabled}
            label={chip.label}
            onClick={() => {
              if (disabled || onFilterChipChange === undefined) {
                return
              }

              onFilterChipChange(chip.id)
            }}
          />
        )
      })}
    </div>
  )
}
